import React from 'react'
import './style.css'
import Button from '../CtaButton'

const NewCtaSection = ({ content }) => {
    return (
        <>
            <section className="new-cta-section-for-hire-page py-5">
                <div className="container text-center">
                    <h2 className="new-cta-section-for-hire-page-heading">{content?.mainHeading}</h2>
                    <p className="description-text-white mb-4">{content?.description}</p>
                    <Button text={content?.btnText} link={content?.btnLink} />
                </div>
            </section>
        </>
    )
}

export default NewCtaSection